import { Injectable } from '@angular/core';

import { BaseProvider } from './base-provider';
import { GlobalsService } from './globals.service';

import { HttpClient } from '@angular/common/http';

import { HttpHelperService } from './http-helper.service';

import { LsHelperService } from './ls-helper.service';
import { Subject } from 'rxjs';
// import { TransactionService } from 'src/app/pages/transaction/services/transaction.service';

@Injectable({
  providedIn: 'root'
})
export class UserProcessProfileService extends BaseProvider{
	proponent: any=[];
	profiles: any=[];
	dataChange: Subject<any> = new Subject();
	isNew: boolean = false;
	cities: any = [];
	countries: any = [];
	states: any = [];
	
  	constructor(
		public globals: GlobalsService,
 		private httpHelper: HttpHelperService,
 		public http: HttpClient,		
 		public ls: LsHelperService,
  	) { 
		super();

		this.baseUrl = "userProcessProfile";		
	}	

	getUserProcessProfiles(processId){
		return new Promise( (resolve, reject) => {
			
			this.url = this.globals.dataUrl + this.baseUrl + '/both/' + processId;

		    this.http
		    .get(this.url)
		    .subscribe(
		        (data: any) => {
		        	this.profiles = data;

		        	resolve(data);
		        }, (error) => {
					//console.log(error);

					reject(error);
				}
		    );
		});		
	}	


	getProponentProfile(processId){
		return new Promise( (resolve, reject) => {
			
			this.url = this.globals.dataUrl + this.baseUrl + '/proponent/' + processId;

		    this.http
		    .get(this.url)
		    .subscribe(
		        (data: any) => {
		        	this.proponent = data;

		        	resolve(data);
		        }, (error) => {
					//console.log(error);

					reject(error);
				}
		    );
		});		
	}	

	search(params){
		return new Promise( (resolve, reject) => {
		  this.url = this.globals.dataUrl + 'adminUserProfile' +
			'/admin/' + params.userId +
			'/term/' + params.term +
			'/page/' + params.pageNumber +
			'/size/' + params.pageSize;
	  
			this.http
			.get(this.url)
			.subscribe(
				(data: any) => {
				  this.list = data.Data;
				  resolve(data.Data);
				},
				err => {reject(err)}
			);
		});
		}

		getLookups(){
			return new Promise( (resolve, reject) => {
			  this.url = this.globals.dataUrl  + 'adminUserProfile' +
					'/admin/lookups';
		
				this.http
				.get(this.url)
				.subscribe(
					(data: any) => {
					  this.cities = data.Data.cities;
					  this.countries = data.Data.countries;
					  this.states = data.Data.states;
		
			  resolve(data);
					},
					err => {reject(err)}
				);
			});
		  }
		
	  

}
